import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import "./audio-future.css";
import "./overlay.css";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
